import DallasSvgIconCloseOutlined from '../../Icons/DallasSvgIconCloseOutlined';
import { Props as DallasButtonProps } from '../DallasButton/DallasButton';
import DallasIconButton from './DallasIconButton';

interface Props
  extends Pick<DallasButtonProps, 'onClick' | 'size' | 'rounded'> {
  className?: string;
  transparent?: boolean;
}

export default function DallasIconButtonClose({
  transparent: isTransparent,
  ...props
}: Props) {
  return (
    <DallasIconButton
      {...props}
      icon={<DallasSvgIconCloseOutlined />}
      aria-label="Close"
      tabIndex={-1}
      color={isTransparent ? 'transparent' : 'tertiary'}
    />
  );
}
